import React from 'react';

import { ArcAlert, ArcText } from '@src/core/ui';

import { useTerrainSeries } from '@src/features/order/pages/upsert-mission-page/hooks';

import { TerrainAlertProps } from './types';

// Match the step 4 (confirm order) message box sizing: tight padding + caption-sized text.
const alertSx = { py: 0.4, px: 1, '& .MuiAlert-icon': { marginLeft: '3px' } };

const TerrainAlert: React.FC<TerrainAlertProps> = () => {
  const { isLoading, hasCrashZoneCollision } = useTerrainSeries();

  if (isLoading) return null;

  if (!hasCrashZoneCollision) {
    return (
      <ArcAlert severity='success' sx={alertSx}>
        <ArcText.caption color='success.main'>
          No terrain collision detected. Current altitudes are safe.
        </ArcText.caption>
      </ArcAlert>
    );
  }

  return (
    <ArcAlert severity='warning' sx={alertSx}>
      <ArcText.caption color='warning.main'>
        Terrain collision detected. Current altitudes are unsafe, adjust them before takeoff.
      </ArcText.caption>
    </ArcAlert>
  );
};

export default TerrainAlert;
